import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';

export const trackStaticMapClick = () => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: TRACKING_CATEGORY,
        eventAction: 'click',
        eventLabel: 'static map'
    });
};

export const trackRefreshSimilarPropertiesSplitTest = (
    label: 'original' | 'variant'
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: 'optimizely',
        eventAction: 'lex-701-similar-listings-refresh',
        eventLabel: label
    });
};
